export class TypeAnomalies {
  static ADMINISTRATIF = 'ADMINISTRATIF';
  static RESULTATS = 'RESULTATS';
  static DOCUMENTS = 'DOCUMENTS';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/constants/TypeAnomalie.ts